import React, { Fragment, useEffect, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PrintIcon from '@material-ui/icons/Print';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import DescriptionIcon from '@material-ui/icons/Description';
import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import AlertModal from '../../../../shared/components/Modal';
import history from '../../../../history';
import ReportsAPI from './../../../Reports/api/reports_api';

const ReactTableActionsReceiptsList = ({ data, loadReceipts, getAdmision }) => {
  //const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [reciptState, setReciptState] = useState(null);
  //const [userReceipt, setUserReceipt] = useState([]);

  const [colorAlertModal, setAlertColorModal] = useState(false);
  const [messageAlertModal, setMessageAlerModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);

  const loadBilling = () => {

    return new Promise((resolve, reject) => {
      var dataBilling = { id_admision: parseInt(data.data.original.id_admision) };
      //console.log(dataBilling);
      fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/admisionpaga', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(dataBilling)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log(data);
          //stateRecipts();
          resolve(data.contenido[0]);

        }).catch((e) => {
          console.log(e);
          reject(e);
        });
    })
  }

  const loadPlan = async (billing) => {

    var dataClose = { id_plan: billing.id_plan };
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar_plan', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataClose)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {

        loadThird(billing, data.contenido[0]);

      }).catch((e) => {
        console.log(e);
      });
  }

  const loadThird = async (billing, plan) => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/ver/' + plan.id_tercero, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
    })
        .then(response => {
            return response.json();
        })
        .then(data => {
          loadDataProfile(billing, plan, data.contenido[0])
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

  const getUser = async (id) => {

    return new Promise((resolve, reject) => {

      const dataToSend = { id_usuario: id };

      fetch(process.env.REACT_APP_PUBLIC_URL + 'usuario/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(dataToSend)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data.contenido[0]);

        }).catch((error) => {
          console.error('Error:', error);
          reject(error);
        });
    });
  }

  const loadDataProfile = async (billing, plan, tercero) => {

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();

      })
      .then(data => {
        console.log(data);
        if (data.length > 0) {
          stateRecipts(billing, plan, tercero, data[0]);
          //printRecipt(billing, plan, data[0]);
        }
      })
      .catch((error) => {
        console.error('Error:', error);

      });
  }

  // consulta estado  recibos de caja 
  const stateRecipts = async (billing, plan, tercero, profile) => {
    let id_admision = parseInt(data.data.original.id_admision);
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-recibos-por-admision?id_admision=' + id_admision, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    }).then(response => {
      return response.json();
    }).then(res => {
      if (res.length > 0) {
        setReciptState(res);
        printRecipt(billing, plan, tercero, profile, res[0]);
      }
    }).catch((error) => {
      console.error('Error:', error);
      setReciptState(null);
    });
  }

  const printRecipt = async (billing, plan, tercero, profile, stateRecipt) => {

    const user = JSON.parse(sessionStorage.getItem('usuario'));

    const userReceipt = await getUser(data.data.original.usuario);

    console.log(profile);
    const today = moment(new Date()).format('MMMM Do YYYY');
    const hour = moment(billing.fecha).format('h:mm a');
    const fechaFac = moment(billing.fecha).format('MMMM Do YYYY');

    const city = profile.direccion.id_ciudad;
    const dept = profile.direccion.id_dpto;
    const getCity = await ReportsAPI.loadCity(city);
    const getDepts = await ReportsAPI.loadDepartment();
    const deptoProfile = getDepts.find((depto) => depto.id === dept)
    console.log("location", getCity, deptoProfile)

    console.log("DATApdfRECIPT", billing, plan, profile, stateRecipt, tercero);
    console.log('OtherData', userReceipt);

    let estado_recibo = data.data.original.recibo_cancelado == true ? "ANULADO" : "RECIBIDO";

    const documentDefinition = {
      pageSize: 'LETTER',
      pageOrientation: 'portrait',
      content: [
        {
          margin: [40, 10, 0, 0],
          layout: 'noBorders',
          table: {
            widths: ['*', '*', 120],
            body: [
              [{
                image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                fit: [100, 50],
              },
              { text: profile.nombre + ' \n Nit. ' + profile.nit + ' \n Teléfonos: ' + profile.telefono1 + '-' + profile.telefono2 + ' ' + profile.direccion.direccion, style: 'head' },
              { text: 'Recibo de caja \n No. ' + billing.num_recibo + "\n" + estado_recibo, style: 'head' }],
            ]

          },
        },
        {
          margin: [0, 30, 0, 0],
          table: {
            widths: ['*'],
            body: [
              [{ text: 'Fecha: ' + getCity[0].ciunom + ', ' + fechaFac + ', Hora: ' + hour, style: 'textStyle' }],
            ]
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: [168, '*'],
            body: [
              [{ text: 'Recibido de ', style: 'textStyle' }, { text: data.data.original.tip_documento + '-' + data.data.original.num_documento + ' ' + data.data.original.nombre_paciente, style: 'textStyle' }],
              [{ text: 'Cliente ', style: 'textStyle' }, {
                text: plan.tipo == 1 ? 'Particular - ' + tercero.nombre :
                  plan.tipo == 2 ? 'Subsidiado - ' + tercero.nombre :
                    plan.tipo == 3 ? 'Contributivo - ' + tercero.nombre :
                      plan.tipo == 4 ? 'Regimen Especial - ' : '' + tercero.nombre, style: 'textStyle'
              }],
              [{ text: 'Paciente ', style: 'textStyle' }, { text: data.data.original.tip_documento + '-' + data.data.original.num_documento + ' ' + data.data.original.nombre_paciente, style: 'textStyle' }],
              [{ text: 'Valor ', style: 'textStyle' }, { text: '$' + billing.total, style: 'textStyle' }],
              [{ text: 'Por Concepto de ', style: 'textStyle' }, { text: billing.tipo_pago, style: 'textStyle' }],
            ]
          },
        },
        {
          columns: [
            {
              // auto-sized columns have their widths based on their content                                       
              margin: [40, 60, 25, 0],
              layout: 'noBorders',
              table: {
                widths: [110],
                headerRows: 1,
                body: [
                  [{ text: '' }],
                  [{ text: 'Cajero ' + stateRecipt.nombre_cajero, style: 'foot', }],

                ]
              },
            },
            {
              // auto-sized columns have their widths based on their content                                       
              margin: [40, 60, 25, 0],
              layout: 'headerLineOnly',
              table: {
                widths: [110],
                headerRows: 1,
                body: [
                  [{ text: '' }],
                  [{ text: profile.nombre + ' \n Nit. ' + profile.nit, style: 'foot', }],

                ]
              },
            },
          ]
        },
        {
          margin: [0, 10, 0, 0],
          text: 'Usuario y fecha de impresión ' + user.nombre + ' - ' + today, style: 'foot',
        },
      ],
      styles: {
        head: {
          fontSize: 8,
          alignment: 'center'
        },
        textStyle: {
          fontSize: 10,
        },
        foot: {
          fontSize: 7
        }
      }
    }

    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
      document.getElementById('pdfV').src = outDoc;
    });
  }

  const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  const cancelReceipt = async () => {
    setAlertColorModal("warning");
    setMessageAlerModal("Esta seguro de cancelar este Recibo de Caja?");
    setShowAlertModal(true);
  }

  const confirmCancelReceipt = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/cancelar-recibo', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify({ id_recibo: data.data.original.id_recibo, estado: true })
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        return response.json();
      }
      else {
        throw new Error("Ha ocurrido un error en el Servidor");
      }
    }).then(data => {

      setAlertColorModal("success");
      setMessageAlerModal("Recibo de Caja Cancelado con exito");
      setShowAlertModal(true);
    }).catch((e) => {
      console.log(e);
      setAlertColorModal("danger");
      setMessageAlerModal("Ha ocurrido un error con el Recibo de Caja");
      setShowAlertModal(true);
    });
  }

  const onOkModalAlert = () => {
    switch (colorAlertModal) {
      case "success":
        cancelModalAlert();
        break;
      case "warning":
        confirmCancelReceipt();
        break;
      case "danger":
        cancelModalAlert();
        break;
    }
  }

  const cancelModalAlert = () => {
    switch (colorAlertModal) {
      case "success":
        console.log("Recargando");
        loadReceipts();
        closeModal();
        break;
      case "warning":
        confirmCancelReceipt();
        closeModal();
        break;
      case "danger":
        cancelModalAlert();
        closeModal();
        break;
    }
  }

  const closeModal = () => {
    setAlertColorModal("info");
    setMessageAlerModal("");
    setShowAlertModal(false);
  }

  const loadDataAdmision = async () => {
    let dataAdmision = await getAdmision(data.data.original.id_admision);
    let goAdmisionData = dataAdmision[0];
    if (goAdmisionData !== null && goAdmisionData !== undefined) {
      history.push({
        pathname: process.env.PUBLIC_URL + '/assitencial/add-admission',
        state: {
          dataPatient: goAdmisionData,
          id_admision: goAdmisionData.id_admision.toString()
        }
      });
    }
  }
  return (<Fragment>
    <td role="cell">
      <Tooltip title="Imprimir">
        <IconButton
          aria-label="print"
          style={{ padding: 2 }}
          onClick={() => {
            setOpenModal(true);
            loadBilling().then((billing) => {
              loadPlan(billing);
            });
          }}
        >
          <PictureAsPdfIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Visualizar Admisión">
        <IconButton
          aria-label="print"
          style={{ padding: 2 }}
          onClick={() => {
            loadDataAdmision();
          }}
        >
          <FindInPageIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Cancelar Recibo de Caja">
        <IconButton
          aria-label="print"
          style={{ padding: 2 }}
          onClick={() => {
            cancelReceipt();
          }}
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>

    </td>

    <Modal
      open={openModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      style={{ zIndex: 1000 }}
    >
      <div className="paperAppointment-flex" style={{ width: '120%', margin: 10 }}>
        <IconButton style={{ float: 'right' }} onClick={() => {
          setOpenModal(false);
        }}>
          <CloseIcon />
        </IconButton>
        <iframe id="pdfV" width="1000" height="600" >

        </iframe>
      </div>
    </Modal>


    <AlertModal
      color={colorAlertModal}
      title={messageAlertModal}
      modal={showAlertModal}
      onOk={() => {
        onOkModalAlert();
      }}
      toggle={() => cancelModalAlert()}
    />


  </Fragment>)
}

export default ReactTableActionsReceiptsList;